<div class="c-page-cardissuancedetails">
    <div class="container u-pb30">
        <div class="row mobile--orange u-pt40">
            <div class="col-md-12" *ngIf="EntryCard">
                <nav aria-label="breadcrumb">
                    <ol class="breadcrumb">
                        <li class="breadcrumb-item"><a  [routerLink]="['/']">{{'CardDetailsPortal.home' | translate}}</a></li>
                        <li class="breadcrumb-item active" aria-current="page">&nbsp; - <a [routerLink]="['/new-cards/list']" >{{'CardDetailsPortal.breadcrumbBack'| translate}}</a></li>
                        <li class="breadcrumb-item active" aria-current="page">&nbsp; - <span>{{'CardDetailsPortal.location'| translate}}</span></li>
                    </ol>
                </nav>
                <h2 class="o-title" *ngIf="EntryCard.type"> {{'CardDetailsPortal.titleNewCard'| translate}} {{idRequest}} </h2>
                <h2 class="o-title" *ngIf="!EntryCard.type"> {{'CardDetailsPortal.titleReplacement'| translate}} {{idRequest}} </h2>
            </div>
        </div>
        <div class="row" *ngIf="EntryCard">
            <div class="col-md-12 u-pt30 u-pb30">
                <h2 class="o-title o-title--medium"><span>{{'CardDetailsPortal.labelStatus'| translate}}: </span>
                    <strong class="gray" *ngIf="EntryCard.status.id===1">{{'CardDetailsPortal.statusPending'| translate}}</strong>
                    <strong class="gray" *ngIf="EntryCard.status.id===2">{{'CardDetailsPortal.statusClosed'| translate}}</strong>
                </h2>
            </div>
            <div class="col-md-12">
                <div class="c-results">
                    <div class="row">
                        <div class="col-md-10 col-md-offset-1">
                            <div class="o-steps">
                                <div class="row">
                                    <div class="col-md-12">
                                        <div class="row">
                                            <div class="col-md-offset-1 col-xs-5 o-steps__step o-steps__step--approved">
                                                <div class="o-steps__circle"><i class="icon icon-check"> </i></div>
                                                <label> {{'CardDetailsPortal.step1' | translate}}</label>
                                                <p>{{'CardDetailsPortal.statusSubmit' | translate}}</p>
                                            </div>

                                            <div class="col-xs-5 o-steps__step" *ngIf="    EntryCard.status.name==='Pending'">
                                                <div class="o-steps__circle"><i class="icon icon-more"> </i></div>
                                                <label>{{'CardDetailsPortal.step2' | translate}}</label>
                                                <p>{{'CardDetailsPortal.statusReview' | translate}}</p>
                                            </div>

                                            <div class="col-xs-5 o-steps__step o-steps__step--rejected" *ngIf="EntryCard.status.name==='Reject'">
                                                <div class="o-steps__circle"><i class="icon icon-close"> </i></div>
                                                <label>{{'CardDetailsPortal.step2' | translate}}</label>
                                                <p>{{'CardDetailsPortal.statusReject' | translate}} </p>
                                            </div>

                                            <div class="col-xs-5 o-steps__step o-steps__step--approved" *ngIf="EntryCard.status.name==='Closed'">
                                                <div class="o-steps__circle"><i class="icon icon-check"> </i></div>
                                                <label> {{'CardDetailsPortal.step2' | translate}}</label>
                                                <p>{{'CardDetailsPortal.statusClosed' | translate}} </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-md-12 u-pt30">
                <div class="u-pb20">
                    <h2 class="o-title o-title--medium o-title--orange">{{'CardDetailsPortal.requestDetails' | translate}} </h2>
                </div>
                <div class="row">
                    <div class="col-md-3 col-lg-2" *ngIf="!EntryCard.type && EntryCard.motive">

                        <p class="o-text u-pb0"> <strong>{{'CardDetailsPortal.replacementMotive' | translate}} :</strong></p>
                        <p class="o-text" *ngIf="getlang()==='en'">{{EntryCard.motive.name}}</p>
                        <p class="o-text" *ngIf="getlang()==='es'">{{EntryCard.motive.nameEs}}</p>
                    </div>
                    <div class="col-md-3 col-lg-2">
                        <p class="o-text u-pb0"> <strong>{{'CardDetailsPortal.labelEmployeeSite' | translate}}</strong></p>
                        <p class="o-text">{{EntryCard['site'].name}}</p>
                    </div>
                    <div class="col-md-3">
                        <p class="o-text u-pb0"> <strong>{{'CardDetailsPortal.labelPickPlace' | translate}}</strong></p>
                        <p class="o-text" *ngIf="getlang()==='en'">{{EntryCard['pickupPlace'].name}}</p>
                        <p class="o-text" *ngIf="getlang()==='es'">{{EntryCard['pickupPlace'].nameEs}}</p>
                    </div>
                </div>
                <hr class="big">
            </div>
            <div class="col-md-12">
                <h2 *ngIf="EntryCard.type" class="o-title o-title--medium o-title--orange">{{'CardDetailsPortal.workerDetails' | translate}} </h2>
                <h2 *ngIf="!EntryCard.type" class="o-title o-title--medium o-title--orange">{{'CardDetailsPortal.workerDetails' | translate}} </h2>
            </div>
            <div class="col-md-12 u-pt20">
                <table class="table table--clean">
                    <thead>
                        <tr>
                            <th>{{'CardDetailsPortal.colNumber' | translate}}</th>
                            <th>{{'CardDetailsPortal.colType' | translate}}</th>
                            <th>{{'CardDetailsPortal.colRutpass' | translate}}</th>
                            <th> {{'CardDetailsPortal.colName' | translate}}</th>
                            <th>{{'CardDetailsPortal.colEmail' | translate}}</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let person of EntryCard['peoples']; index as i">
                            <td class="table__number">
                                <p class="green">{{i+1}} </p>
                            </td>
                            <td>
                                <p><span *ngIf="person.passportNumber" >{{'CardDetailsPortal.colPassport' | translate}}</span><span *ngIf="person.passportNumber && person.nationalId"> / </span> <span *ngIf="person.nationalId" >{{'CardDetailsPortal.colRUT' | translate}}</span></p>
                            </td>
                            <td>
                                <p><span *ngIf="person.passportNumber" >{{person.passportNumber}}</span><span *ngIf="person.passportNumber && person.nationalId"> / </span> <span *ngIf="person.nationalId" >{{person.nationalId}}</span></p>
                            </td>
                            <td>
                                <p>{{person.firstName}} {{person.lastName}} </p>
                            </td>
                            <td>
                                <p>{{person.email}}</p>
                            </td>
                        </tr>

                    </tbody>
                </table>
            </div>
        </div>
    </div>
</div>